import React, { ReactNode } from "react";
import appMockUp from "assets/appMockUp.png";
import checkBoxesImg from "assets/checkBoxes.png";
import smiley from "assets/smily.png";
import smileyS from "assets/smilyS.png";
import smiley2 from "assets/smilyS-v2.png";
import CTA from "components/CTA";

const CreateAWill = () => (
	<div className="w-screen mb-28">
		{/* Section 1 - Intro */}
		<section className="md:px-16 px-10 bg-darkblue py-16 md:py-28 mb-0">
			<h2 className="text-white">
				Let’s create a will<span className="text-primary">.</span>
			</h2>
			<h2 className="text-white">
				<span className="text-primary">
					(Don’t worry, we’ll make it deadeasy.)
				</span>
			</h2>
			<div className="flex gap-4 flex-col justify-start item-start md:w-[50%]">
				<h3 className="text-white">It’s time to check some boxes.</h3>
				<p className="text-white">
					We’ll try to make this as painless and as fun as possible, which isn’t
					easy given we’re talking about your demise.
				</p>
				<div className="mt-8 md:flex md:justify-start">
					<CTA color="primary" title="Create my will" />
				</div>
			</div>
		</section>

		{/* Section 2 - step 1 */}
		<section className="flex mb-0">
			<div className="flex flex-col gap-4 lg:w-[50%] md:px-16 px-10 bg-white py-16 md:py-16 box-border">
				<div className="">
					<img
						className="w-[60px] h-[60px] relative"
						alt="smiley"
						src={smiley}
					/>
				</div>
				<h3>Firstly, answer a few simple questions</h3>
				<p className="">
					About yourself, those you care about and trust, and the things you
					value. This quick and easy questionnaire will populate your will.
				</p>
			</div>
			<div className="md:w-[50%] relative max-lg:hidden">
				<img
					className="w-[100%] h-[100%] object-none"
					alt="pint"
					src={checkBoxesImg}
				/>
			</div>
		</section>
		{/* Section 3 - step 2 */}
		<section className="flex bg-orange py-16 md:py-16 box-border mb-0 justify-center">
			<div className="flex flex-col gap-4 md:px-16 px-10 lg:max-w-[50%] justify-center text-center">
				<div className="flex justify-center">
					<img
						className="w-[60px] h-[60px] relative"
						alt="smiley"
						src={smiley2}
					/>
				</div>
				<h3 className="text-white">
					Then, one of our team will do a quick check of the Will
				</h3>
				<p className="text-white">
					To make sure your wishes are clear and there are no errors in the
					final document. Don’t worry, it shouldn’t take more than a few hours
					to check and we will notify you when it’s ready.
				</p>
			</div>
		</section>

		{/* Section 4 - step 3 */}
		<section className="flex mb-0 flex-wrap">
			<div className="lg:w-[50%] relative bg-cover bg-center">
				<img
					className="h-[100%] object-cover"
					alt="app mock up"
					src={appMockUp}
				/>
			</div>
			<div className="flex flex-col gap-4 lg:w-[50%] md:px-16 px-10 bg-white py-16 md:py-16 box-border lg:text-right">
				<div className="flex lg:justify-end">
					<img
						className="w-[60px] h-[60px] relative"
						alt="smiley"
						src={smileyS}
					/>
				</div>
				<h3>Finally you’ll need to make it legal</h3>
				<p className="">
					Print and sign it in front of two witnesses to make it legally
					binding. You can either download your will to print at home, or we can
					print and post it to you.
				</p>
				<p className="">
					And that’s it, you’re finally ready to kick the bucket…
				</p>
				<p className="">
					Our pricing starts at £10 for a single Will and just £15 for a couples
					Will. Plus, you can come back, login and make unlimited changes for as
					long as you are kicking about.
				</p>
			</div>
		</section>
		{/* Section 5 - CTA */}
		<section className="flex bg-darkblue py-16 md:py-24 box-border mb-0 justify-center">
			<div>
				<CTA color="secondary" title="Create my will" />
			</div>
		</section>
	</div>
);

export default CreateAWill;
